<template>
  <div v-if="!occupied" class="chatter-filter">
    <div>      
      <b-row class="d-flex align-items-center">
        <!-- Project -->
        <b-col>
          <div class="text-container keyword-label-area">
            <label for="project-list">Project</label>
            <div class="search-toggle-area">
              <span> With Closed </span>
              <b-input-group-append is-text>
                <b-form-checkbox switch class="mr-2" v-model="isProjectToggled" :value="true" :unchecked-value="false">
                </b-form-checkbox>
              </b-input-group-append>
            </div>
          </div>
          <b-dropdown id="project-list" variant="secondary" @change="reload" v-model="filter.projectId" class="w-100">
            <template #button-content>
              <span>{{ selectedProjectName }}</span>
            </template>
            <b-dropdown-item v-for="option in options('project')" :key="option.value" :value="option.value"
              @click="setProject(option.value)">
              {{ option.text }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
        <!-- /Project -->
        <!-- Status -->
        <b-col>
          <div class="text-container keyword-label-area">
            <label for="status-list">Status</label>
          </div>
          <b-dropdown id="status-list" class="w-100">
            <template #button-content class="status-list">
              <span>{{ searchOptionsLabel }}</span>
              <!-- Search Options Label-->
              <span class="icon"></span>
            </template>
            <b-dropdown-item v-for="option in options('status')" :key="option.value" :value="option.value"
              @click="setStatus(option.value)">
              {{ option.text }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
        <!-- /Status -->
        <!-- Assignee -->
        <b-col>
          <div class="text-container keyword-label-area">
            <label for="assignee-list">Assignee</label>
          </div>
          <b-dropdown id="assignee-list" variant="secondary" @change="reload" v-model="filter.assignee" class="w-100">
            <template #button-content>
              <span>{{ selectedAssigneeName }}</span>
            </template>
            <!-- currentUser 랑 assignee 가 일치할 때 dropdown 에 표시  -->
            <!-- <b-dropdown-item v-if="option.value === userId" v-for="option in assigneeOptions" :key="option.text"
              :value="option.value" @click="setAssignee(option.value)">
              {{ option.text }}
            </b-dropdown-item> -->
            <b-dropdown-item v-for="(option, index) in assigneeOptions" :key="option.value" :value="option.value"
              @click="setAssignee(option.value)">
              {{ option.text }}
            </b-dropdown-item>
            <!-- <div v-if="index === 0" class="dropdown-toggle-line" :class="{ 'open': this.visible }"></div> -->
          </b-dropdown>
        </b-col>
        <!-- /Assignee -->
        <!-- Keyword -->
        <b-col>
          <div class="text-container keyword-label-area">
            <label for="Keyword">Keyword</label>
            <div class="search-toggle-area">
              <span>With Comment</span>
              <b-input-group-append is-text>
                <b-form-checkbox switch class="mr-2" v-model="filter.keywordWithComment" :value="true"
                  :unchecked-value="false">
                </b-form-checkbox>
              </b-input-group-append>
            </div>
          </div>
          <b-input-group size="sm">
            <b-form-input placeholder="Keyword" @keyup.enter="reload" v-model="filter.keyword" />
          </b-input-group>
        </b-col>
        <div style="padding-left: 1em; border-left: 1px solid rgb(221, 221, 221);">
          <base-button style="width: 148px; height: 40px;" variant="primary"
            @click="pushRoute('/chatter/edit')"
            :disabled="!isCreatable">Create</base-button>
          <!-- <b-button class="btn-create btn-primary small" 
                    @click="pushRoute('/chatter/edit')">
                    Create
          </b-button> -->
        </div>
        <!-- /Keyword -->
        <!-- hierarchy -->
        <!-- <b-col cols="1" class="">
          <button class="hierarchy-switch" :style="hierarchySwitchStyle" @click="handleChangeHierarchy">
            <b-icon :icon="this.filter.hierarchy ? 'list-nested' : 'list'" font-scale="2"/>
          </button>
        </b-col> -->
        <!-- /hierarchy -->
      </b-row>
      <!-- Search detail button -->
      <b-col class="d-flex justify-content-center" style="flex-grow: 0;">
        <div @click="expandSearchDetail" class="toggle-line" :class="{ 'open': this.visible }">
          <span>Search Detail</span>
        </div>
      </b-col>
      <!-- /Search detail button -->
    </div>
    <!-- Search detail collapse -->
    <div>
      <b-collapse id="collapse-4" v-model="visible">
        <!-- Info 버튼 클릭시 테이블 정보 이미지 로드 -->
        <img v-if="isInfoClicked" src="../../../assets/images/search_detail_info.png" alt="search_detail_info"
          class="info-image" />
        <b-row style="align-items: flex-start; height: auto;" class="search-detail-area">
          <b-col class="col-3">
            <b-row>
              <div class="select-box">
                <div class="select-title">Saved Queries</div>
                <b-form-select label="Saved Queries" v-model="queryId" :options="queryOptions" value-field="id"
                  text-field="name" :select-size="4" @change="querySelected" class="new-query">
                </b-form-select>
              </div>
            </b-row>
            <b-row style="justify-content: space-between; width: 100%; margin-top: 0.5208vw;">
              <b-button class="btn btn-primary col" @click="queryChanged" :disabled="isQueryId">
                <span>Load</span>
              </b-button>
              <b-button class="btn btn-secondary col" variant="outline-danger" @click="deleteQuery()"
                :disabled="isQueryId">
                <span>Delete</span>
              </b-button>
            </b-row>
          </b-col>
          <b-col>
            <b-row class="search-detail-area">
              <b-col>
                <b-form-group id="fieldset-horizontal" style="margin-bottom: 0;">
                  <b-form-input id="input-horizontal" name="condition" placeholder="Enter title..." v-model="queryTitle"
                    ref="title">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="query-button">
                <b-button v-b-toggle.collapse-1 class="btn btn-secondary small" variant="outline-info"
                  @click="retrieveTableInfo()"><span>Info</span></b-button>
              </b-col>
              <b-col class="query-button">
                <b-button class="btn btn-primary small" variant="outline-danger" @click="clear()">
                  <span>Clear</span>
                </b-button>
              </b-col>
              <b-col class="query-button">
                <b-button class="btn btn-primary" variant="outline-primary" @click="showQuerySaveModal()"
                  :disabled="isCondition">
                  Save
                </b-button>
                <b-modal ref="query-save-modal" hide-footer title="Save Conditions">
                  <div class="d-block text-center">
                    <p>Do you want to create new condition? </p>
                  </div>
                  <div style="display: flex; gap:1em; justify-content: flex-end;">
                    <b-button @click="newQuery()"> Create New</b-button>
                    <b-button @click="updateQuery()"> Overwrite</b-button>
                  </div>
                </b-modal>
              </b-col>
            </b-row>
            <b-row class="search-detail-area" style="align-items: flex-start;">
              <b-col>
                <b-form-textarea id="textarea" v-model="query" placeholder="Enter query..." style="height: 136px;">
                </b-form-textarea>
                <b-form-textarea id="textarea" v-model="queryOrderBy" placeholder="Enter query after 'ORDER BY' ..."
                  style="height: 40px; margin-top: 0.5208vw;">
                </b-form-textarea>
              </b-col>
              <b-col class="query-button">
                <b-button class="btn btn-primary big" variant="outline-primary" @click="runQuery()"
                  :disabled="canRunQuery">
                  <span>Run</span>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
    <!-- /Button Group -->
    <!-- TODO -->
  </div>
  <!-- /Search detail collapse -->
</template>

<script>
import RefreshIcon from "@/components/chatter/icons/RefreshIcon.vue";
import BaseButton from "../requirement/BaseButton.vue";
export default {
  name: "ChatterFilter",
  components: {
    RefreshIcon,
    BaseButton
  },
  //isRefreshed: Chatter List에서 새로고침 되었는지
  props: {
    isRefreshed: {
      type: Boolean,
      required: false,
    },
    isCreatable: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    filter() {
      return this.$store.getters['chatter/filter'];
    },
    firstHalfItemInfo() {
      const halfIndex = Math.ceil(this.tableInfo.length / 2);
      return this.tableInfo.slice(0, halfIndex);
    },
    secondHalfItemInfo() {
      const halfIndex = Math.ceil(this.tableInfo.length / 2);
      return this.tableInfo.slice(halfIndex);
    },
    hierarchySwitchStyle() {
      return this.filter.hierarchy ? { backgroundColor: '#2E2E38', color: 'white' } : { backgroundColor: '#DDDDE3', color: 'black' };
    },
    isCondition() {
      return this.queryTitle == '' || this.query == '';
    },
    isQueryId() {
      return !this.queryId;
    },
    //queryTitle, query state 조건 만족 여부
    isQueryTitle() {
      //기존 condition Load 전 or 첫 화면에서는 비활성화
      if (this.currQueryTitle.length == 0 || this.queryId == null) return null;
      return this.queryTitle.length > 0 ? true : false;
    },
    isQueryOrderBy() {
      //기존 condition Load 전 or 첫 화면에서는 비활성화
      if (this.currQueryOrderBy.length == 0 || this.queryId == null) return null;
      return this.queryOrderBy.length > 0 ? true : false;
    },
    isQuery() {
      //기존 condition Load 전 or 첫 화면에서는 비활성화
      if (this.currQuery.length == 0 || this.queryId == null) return null;
      return this.query.length > 0 ? true : false;
    },
    //query run 버튼 활성화 여부
    canRunQuery() {
      return ((this.query != null) && this.query.length > 0) || (this.query != null && this.queryOrderBy != null && this.query.length > 0 && this.queryOrderBy.length > 0) ? false : true;
    },
    statusBar() {
      return this.$store.getters['chatter/statusBar'];
    },
    projectOptions() {
      return this.$store.getters['chatter/options']['projectOptions'];
    },
    occupied() {
      return this.$store.getters['chatter/occupied'];
    },
    isInfoClicked() {
      return this.getToggle.filterInfo;
    },
    toggleFilterSearchDetail() {
      return this.getToggle.filterSearchDetail;
    },
    // getToggleText() {
    //   return this.toggleFilterSearchDetail ? 'Clear' : 'Search Detail';
    // },
    getSearchDetailInfo() {
      return this.$store.getters['chatter/getSearchDetailInfo'];
    },
    getToggleFilterClosedProjects() {
      return this.filter.withClosedProjects;
    },
    getToggle() {
      return this.$store.getters['chatter/toggle'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    userId() {
      return this.currentUser.caller;
    },
    selectedProjectName() {
      const selectedProjectId = this.filter.projectId;

      if (selectedProjectId == '') return 'All Projects';


      const project = this.projectOptions.find(project => project.projectId === selectedProjectId);
      if (project) {
        return project.name;
      }
    },
    searchOptionsLabel() {
      let status = this.filter.status;
      let subStatus = this.filter.subStatus;

      //Summary 나 Filter에 있는 Status를 눌러서 데이터가 있을 때마다
      //retrieveChatterList api 가 호출될때마다 변경
      //onStatusSelected와 setStatus 에서 setStatus로 searchOptionsLabel에 데이터 설정한걸 가지고오기
      let label = this.$store.getters['chatter/searchOptionsLabel'];


      let statusFilter = 'All Status';


      if (label) {

        if (status == 'IN_PROGRESS') {

          if (subStatus == 'OVERDUE') return 'In Progress > Overdue';
          else if (subStatus == 'TODAY') return 'In Progress > Today';
          else if (subStatus == 'SCHEDULED') return 'In Progress > Scheduled';
          else if (subStatus == 'TBD') return 'In Progress > TBD';
          else if (!subStatus) return 'In Progress';

        } else if (status == 'TO_DO') {

          if (subStatus == 'OVERDUE') return 'To Do > Overdue';
          else if (subStatus == 'TODAY') return 'To Do > Today';
          else if (subStatus == 'SCHEDULED') return 'To Do > Scheduled';
          else if (subStatus == 'TBD') return 'To Do > TBD';
          else if (!subStatus) return 'To Do';


        } else if (status == 'OPEN') {
          return 'Open';
        } else if (status == 'ACTIVE') {
          return 'Active';
        } else if (status == 'DONE') {
          return 'Done';
        } else if (status == 'CLOSED') {
          return 'Closed';
        } else if (status == 'CANCELLED') {
          return 'Cancelled';
        }

        if (status) {
          statusFilter = status;
        }

        if (subStatus) {
          statusFilter = `${status} ` + `>` + `${subStatus} `;
        }

      }
      return statusFilter;
    },
    selectedAssigneeName() {
      const selectedAssigneeId = this.filter.assignee;
      if (selectedAssigneeId == '') return 'All Assignees';

      const assignee = this.assigneeOptions.find(assignee => assignee.value === selectedAssigneeId);

      if (assignee) {
        return assignee.text;
      }
    },
    assigneeOptions() {
      const defaultOption = {text : `${this.currentUser.userkorname} (${this.currentUser.caller})`, value: this.currentUser.caller}
      const allAssigneesOption = {text: "All Assignees", value: ''}

      let options = this.getAssigneeOptionsByProjectId(this.filter.projectId);
      options = options.filter(member => member.value !== this.currentUser.caller);

      return [defaultOption, allAssigneesOption, ...options];

      // return this.$store.getters['chatter/options']['assigneeOptions'];
    },
  },
  watch: {
    //refresh 버튼 클릭여부
    isRefreshed() {
      //refresh 클릭시(refresh 동작)
      //filter 활성화
      this.isFilterDisabled = false;
      //Info 닫기
      this.$store.commit('chatter/setToggleFilterInfo', false);
      //search detail 닫기
      this.visible = false;
      //Without Closed Projects로 초기화
      this.isProjectToggled = false;
      //query 관련 사용자 작성 내용 초기화
      this.clearQuery();
      //선택되지 않은 상태로
      this.queryId = null;

    },
    //with closed projects, without closed projects toggle
    isProjectToggled() {
      //filter에 toggle 상태 저장
      // this.$store.commit('chatter/setToggleFilterClosedProjects', this.isProjectToggled);
      this.filter.withClosedProjects = this.isProjectToggled;
      //without closed
      if (this.getToggleFilterClosedProjects == false) {
        //현재 선택한 project가 closed이면 -> without closed 로 바꾸면 'All Projects'를 조회하도록
        if (this.filter.projectId != '' && this.projectOptions.filter(obj => obj.projectId == this.filter.projectId)[0].status == 'CLOSED') {
          //filter의 project 초기화
          this.setProject("");
        } else {
          this.setProject(this.filter.projectId);
        }
      }
    }
  },
  data() {
    return {
      //Search Detail 창
      visible: false,
      queryId: null,
      query: '',
      queryTitle: '',
      queryOrderBy: '',
      queryOptions: [],
      tableInfo: [],
      //현재 condition 값
      currQuery: '',
      currQueryTitle: '',
      currQueryOrderBy: '',
      isProjectToggled: false,
      isFilterDisabled: false,
      toggleText: 'Search Detail',
      loadedQueryId: null,
      showSubStatusDropdown: false,
      showSubStatusDropdownValue: ''
    }
  },
  created() {
    this.retrieveQueries();
    this.$store.dispatch('chatter/retrieveAssigneeOptions');
    //this.$store.dispatch('chatter/retrieveProjectOptions');
    //with closed projects toggle 상태 유지
    this.isProjectToggled = this.filter.withClosedProjects;

    //실행했던 쿼리 내용 남아있도록
    this.setQueryInfo();
    this.visible = this.getToggle.filterSearchDetail;

    /** 23-10-11 
     * Chatter Top Bar에서 최초 dispatch 하고
     * 이후 부터는 중앙 저장소에서 가져오는 식으로 변경
     *  */
    // this.$store.dispatch('chatter/retrieveProjectOptions');

  },
  methods: {
    options(type) {
      let optionsObj = this.$store.getters['chatter/options'][type + 'Options'];
      let allOption = null;
      switch (type) {
        case 'project':
          allOption = { value: "", text: "All Projects" };
          //toggle 여부에 따라 보이는 project 다르게
          if (this.isProjectToggled == false) {
            return [allOption, ...optionsObj.filter(obj => obj.status == "OPEN")]
          }
          break;
        case 'status':
          allOption = { value: "", text: "All Status" };
          break;
        case 'assignee':
          allOption = { value: "", text: "All Assignees" };
          break;
      }
      return [allOption, ...optionsObj];
    },
    getAssigneeOptionsByProjectId(projectId) {
      let memberList = [];
      const projectInfoList = this.projectOptions;

      if (projectId) {
        const selectedProjectInfo = projectInfoList.filter(obj => obj.projectId === projectId)[0]

        if (selectedProjectInfo) {
          memberList = selectedProjectInfo.projectUserList.map(item => ({
            value: item.userId,
            text: `${item.userName} (${item.userId})`
          })).slice().toSorted((a, b) => {
            return a.text.localeCompare(b.text);
          })
        }
      } else {
        // All Projects 선택 시
        let allMembers = [];
        for(let i = 0; i < projectInfoList.length; i++) {
          const projectInfo = projectInfoList[i];

          // 필터의 withClosedProjects 값이 false면 OPEN인 프로젝트의 멤버만 추가
          if (!this.filter.withClosedProjects && projectInfo.status === "CLOSED") {
            continue;
          }
          allMembers.push(...projectInfo.projectUserList)
        }

        // 사용자가 속한 모든 프로젝트의 멤버를 합친 후 집합을 리턴
        memberList = allMembers.reduce((acc, member) => {
          if (!acc.some(item => item.value === member.userId)) {
            acc.push({text : `${member.userName} (${member.userId})`, value: member.userId});
          }
          return acc;
        }, []);
      }

      return memberList;
    },
    runQuery() {
      //this.$store.commit('chatter/setUpdated', 'N');
      //filter 클릭시 status bar 해제
      this.$store.commit('chatter/setOccupied', false);

      //저장된 condition인 경우
      if (this.queryId != null) {
        //선택한 queryId filter에 저장
        this.$store.commit('chatter/setQueryId', this.queryId);
      }
      //저장되어있지 않은 condition인 경우는 아래에서 사용자가 작성한 내용만 저장
      //작성한 쿼리 정보 filter에 저장(title, query, order by)
      this.saveFilterQueryInfo();

      //Run 후에는 작성중인 Search Detail 창 열어두기
      this.$store.commit('chatter/setToggleFilterSearchDetail', true);
      this.$emit('reload');
    },
    reload() {

      // this.filter.subStatus = "";
      //filter 클릭시 status bar 비활성화
      this.$store.commit('chatter/setOccupied', false);
      //statusbar 정보 초기화
      // this.$store.commit('chatter/resetStatusBack');
      this.$store.commit('chatter/setFilterOccupied', true);
      this.$emit('reload');
    },
    expandSearchDetail() {
      this.visible = !this.visible;
      this.$store.commit('chatter/setToggleFilterSearchDetail', this.visible);
      if (this.visible === false) {
        this.filter.query = null;
        this.toggleText = 'Search Detail';
      } else {
        this.toggleText = 'Close';
      }
    },
    queryChanged() {
      //선택한 condition의 내용 보여주기
      const selectedOption = this.queryOptions.find(option => option.id === this.queryId);
      this.query = selectedOption.query;
      this.queryTitle = selectedOption.name;
      this.queryOrderBy = selectedOption.queryOrderBy;
      //현재 condition 값 저장(선택된 당시의 condition 정보와 사용자가 수정한 정보를 비교하기 위한 변수)
      this.currQueryTitle = this.queryTitle;
      this.currQuery = this.query;
      this.currQueryOrderBy = this.queryOrderBy;
    },
    querySelected() {
      this.clearQuery();
    },
    async retrieveQueries() {
      //todo 쿼리 리스트 조회
      let response = await axios.get("chatter/selectRetrieveQueryList", {
        params: {},
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      this.queryOptions = response.data;
    },
    async deleteQuery() {
      if (this.queryId) {
        await axios.post("chatter/removeRetrieveQuery/" + this.queryId, {}, {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        })
      } else {
        this.clearQuery();
        return;
      }
      // TODO 삭제 API 호출
      this.queryId = null;
      //보이는 query 내용 초기화
      this.clearQuery();
      //선택되어있던 query 내용 초기화(delete 실행 후 아무것도 클릭되어있지 않도록)
      this.$store.commit('chatter/resetQuery');
      this.retrieveQueries();
    },
    async updateQuery() {
      let param = {
        query: this.query,
        name: this.queryTitle,
        queryOrderBy: this.queryOrderBy
      }
      param.id = this.queryId;
      await axios.post("chatter/updateRetrieveQuery", param, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      this.retrieveQueries();
      this.$refs['query-save-modal'].hide();

      //수정한 부분 curr에 갱신
      this.currQueryTitle = this.queryTitle;
      this.currQuery = this.query;
      this.currQueryOrderBy = this.queryOrderBy;

    },
    async newQuery() {
      let param = {
        query: this.query,
        name: this.queryTitle,
        queryOrderBy: this.queryOrderBy
      }
      param.id = this.queryId;
      await axios.post("chatter/addRetrieveQuery", param, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      //새로 작성한거 목록에 갱신되는 것 기다리기
      await this.retrieveQueries();
      //가장 최근에 작성된 codition의 id 가져오기(condition 추가하면 추가한 condition이 선택되어있도록 하기 위함)
      this.queryId = this.queryOptions[this.queryOptions.length - 1].id;
      this.$refs['query-save-modal'].hide();
    },
    async retrieveTableInfo() {
      let response = await axios.get("chatter/retrieveFieldInfo", {
        params: {},
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      });
      this.tableInfo = response.data;
      let prevIsInfoClicked = this.getToggle.filterInfo;
      //info 열기
      this.$store.commit('chatter/setToggleFilterInfo', !prevIsInfoClicked);
    },
    //query 내용 초기화하는 함수
    clearQuery() {
      this.queryTitle = '';
      this.query = '';
      this.queryOrderBy = '';
    },
    //Clear 버튼 클릭시 실행되는 함수
    clear() {
      this.clearQuery();
      //선택되었던 queryId 초기화
      this.queryId = null;
      this.$store.commit('chatter/resetFilter');
      //query 초기화니까 조회된 목록도 초기화
      this.$emit('reload');
    },
    showQuerySaveModal() {
      //새로운 condition 작성인 경우(선택된 queryId가 없음)
      if (this.queryId == null) {
        this.newQuery();
        return;
      }
      //query title이 기존이랑 같으면(수정된게 없으면) -> update
      if (this.currQueryTitle == this.queryTitle) {
        this.updateQuery();
        return;
      }

      //query title이 기존이랑 다르면 -> 알림창 -> Create New vs Overwrite 선택
      this.$refs['query-save-modal'].show()
    },
    saveFilterQueryInfo() {
      //작성한 쿼리 정보 filter에 저장(title, query, order by)
      this.$store.commit('chatter/setQueryTitle', this.queryTitle);
      this.$store.commit('chatter/setQuery', this.query);
      this.$store.commit('chatter/setQueryOrderBy', this.queryOrderBy);
    },
    setQueryInfo() {
      this.queryId = this.filter.queryId;
      this.queryTitle = this.filter.queryTitle;
      this.query = this.filter.query;
      this.queryOrderBy = this.filter.queryOrderBy;
      this.currQueryTitle = this.queryTitle;
      this.currQuery = this.query;
      this.currQueryOrderBy = this.queryOrderBy;
    },
    handleChangeHierarchy() {
      this.filter.hierarchy = !this.filter.hierarchy;
      this.reload();
    },
    showSubStatus(value) {
      this.showSubStatusDropdownValue = value;
      this.showSubStatusDropdown = true;
    },
    hideSubStatus() {
      this.showSubStatusDropdown = false;
    },
    setStatus(value) {

      this.filter.status = value;

      // TO_DO나 IN_PROGRESS 상태이면서 subStatus가 있는 경우에만 subStatus 초기화
      // if (!['TO_DO', 'IN_PROGRESS'].includes(value)) {
      this.filter.subStatus = "";
      // }

      this.reload();

      //setStatus 가 눌러지면 setSearchOptionsLabel가 실행
      this.$store.commit('chatter/setSearchOptionsLabel', value);

    },
    setProject(value) {
      // 프로젝트 변경 시 
      // 현재 선택되어있는 assignee 필터 값이 있다면
      // 선택한 프로젝트에 해당 assignee가 멤버로 있는지 검사 후 있으면 유지
      // 없으면 초기화
      this.filter.projectId = value;
      const memberList = this.getAssigneeOptionsByProjectId(value);
      const findAssignee = memberList.find(member => member.value === this.filter.assignee);
      if (!findAssignee) {
        this.filter.assignee = '';
      }
      // if (value && this.filter.assignee) {
      //   const memberList = this.getAssigneeOptionsByProjectId(value);
      //   const findAssignee = memberList.find(member => member.userId === this.filter.assignee);
      //   if (!findAssignee) {
      //     this.filter.assignee = '';
      //   }
      // }

      // if (!value) {
      //   const memberList = this.getAssigneeOptionsByProjectId(value);
      // }

      this.reload();
    },
    setAssignee(value) {

      this.filter.assignee = value;

      this.reload();
    },
  }
}
</script>
<style scoped></style>
<style>
.text-container {
  white-space: nowrap;
  /* 텍스트가 줄바꿈되지 않도록 설정 */
  overflow: hidden;
  /* 너비를 초과하는 텍스트를 감추기 */
  text-overflow: ellipsis;
  /* 초과된 텍스트를 "..."으로 표기 */
}

/* 신규 추가 스타일 */
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');


/* button */
.chatter-list .btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  border: none;
}

.chatter-list .btn:focus {
  box-shadow: none;
}

.chatter-list .btn-secondary {
  width: 148px;
  height: 60px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.chatter-list .btn-secondary.small {
  height: 40px;
  justify-content: cneter !important;
}

.chatter-list .btn-secondary:hover {
  background-color: #565662;
}

.chatter-list .btn-secondary.disabled,
.chatter-list .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.chatter-list .btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

.chatter-list .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.chatter-list .btn-primary.disabled,
.chatter-list .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.chatter-list .btn-primary.small {
  width: 148px;
  height: 40px;
}

.chatter-list .card-body .btn-wrap {
  display: flex;
  gap: 0 2rem;
  justify-content: end;
  margin-top: 3rem;
  margin-bottom: 1.33rem;
}

.chatter-list .btn-wrap .btn-group-area {
  position: relative;
  display: flex;
  gap: 0 0.666rem;
}

.chatter-list .btn-wrap .btn-group-area::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  right: -1rem;
  transform: translateY(-50%);
  width: 1px;
  height: calc(100% - 1.066rem);
  background-color: #DDDDE3;
}

/* select */
.chatter-list .custom-select {
  padding: 0.533rem 2.1rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.chatter-list .chatter-list .custom-select:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

/* new-query select */
.chatter-list .custom-select.new-query {
  background-color: #FFF;
  overflow-y: hidden;
  padding: 1.066rem !important;
  min-height: 180px;
}

.chatter-list .custom-select.new-query:focus,
.chatter-list .custom-select.new-query:checked {
  box-shadow: none;
  border: 1px solid #E7E7EE;
}

.chatter-list .custom-select.new-query option {
  border-radius: 5px;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  padding: 0.466rem 0.8rem;
}

/* input */
.chatter-list .label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

input.form-control,
.chatter-list .input-group-sm>.form-control {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px !important;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
}

input.form-control::placeholder {
  color: #AAA;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

/* form */
.chatter-list .row {
  align-items: flex-end;
  margin-left: -0.7812vw;
  margin-right: -0.7812vw;
}

.chatter-list .row>.col,
.chatter-list .row>[class*="col-"] {
  padding-right: 0.78125vw;
  padding-left: 0.7812vw;
}

/* keyword 영역 */
.keyword-label-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.keyword-label-area span {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
}

.keyword-label-area .search-toggle-area {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
  margin-bottom: 0.5rem;
}

.search-toggle-area .input-group-append {
  position: relative;
  width: 32px;
  height: 16px;
  margin-left: 0;
}

.search-toggle-area .input-group-append .input-group-text {
  padding: 0;
  background-color: transparent;
  border: none;
}

.search-toggle-area .input-group-append .custom-switch {
  width: 100%;
  height: 100%;
  padding: 0;
  margin-right: 0 !important;
  min-height: unset;
}

.search-toggle-area .input-group-append .custom-switch .custom-control-input:focus~.custom-control-label::before {
  box-shadow: none;
}

.search-toggle-area .input-group-append .custom-switch .custom-control-label {
  width: 100%;
  height: 100%;
}

.chatter-filter .search-toggle-area .input-group-append .custom-switch .custom-control-label::before {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 32px;
  height: 18px;
  pointer-events: none;
  content: "";
  background-color: #DDDDE3;
  border: none;
  border-radius: 50px;
}

.chatter-filter .search-toggle-area .input-group-append .custom-switch .custom-control-label::after {
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background-color: #FFF;
  border-radius: 80px;
}

.chatter-filter .search-toggle-area .input-group-append .custom-switch .custom-control-input:checked~.custom-control-label::before {
  background-color: #142459;
}

.chatter-filter .search-toggle-area .input-group-append .custom-switch .custom-control-input:checked~.custom-control-label::after {
  background-color: #FFF;
  transform: translateX(100%);
}

.chatter-filter .hierarchy-switch {
  border: none;
  border-radius: 40px;
}

/* query 영역 */
.chatter-list .query-title {
  height: auto !important;
  padding: 0 0 0 0.4rem !important;
  margin-bottom: 0.53rem;
  background-color: #FFF;
  border: none;
  border-radius: 0;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.chatter-list .query-title::placeholder {
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.chatter-list .query-title:focus {
  border-color: unset;
  box-shadow: unset;
}

.chatter-list textarea {
  min-height: 50px;
  padding: 0.666rem 1.066rem;
  margin: 0;
  line-height: normal;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background: #F6F6FA;
}

/* info 영역 */
.info-table-wrap ul {
  padding-left: 0;
}

.info-table-wrap li {
  list-style: none;
}

.info-table-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 2.666rem;
  width: 100%;
  margin-bottom: 2.666rem;
  font-family: 'NanumGothic';
}

.info-table-wrap .info-table {
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  margin-bottom: 0;
  text-decoration: none;
  border-radius: 10px;
  overflow: hidden;
  background-color: #F6F6FA;
  color: #2E2E38;
  font-size: 14px;
}

.info-table-wrap .info-table .column {
  width: 50%;
}

.info-table-wrap .info-table .column .title {
  font-weight: 700;
  line-height: 60px;
  padding-left: 1.333rem;
}

.info-table-wrap .info-table .column .contents {
  padding: 0;
}

.info-table-wrap .info-table .column .content {
  line-height: 60px;
  border-bottom: 1px solid #E7E7EE;
  padding: 0 1.333rem;
}

.info-table-wrap .info-table .column .content:last-child {
  border-bottom: 0;
}

.info-table-wrap .info-table .column .content.blank {
  font-size: 0;
}

.query-button {
  justify-content: end;
  display: flex;
}

.query-run-button {
  align-items: center;
  justify-content: center !important;
  display: flex;
  min-height: 180px;
}

.query-list-button {
  width: 130px;

}

.info-image {
  width: 100%;
  height: 100%;
  padding: 0 0 30px 0;
}

/* search detail */
.toggle-line {
  position: relative;
  display: block;
  width: 100%;
  margin: 15px 0;
  text-align: center;
}

.toggle-line::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #DDDDE3;
  transform: translateY(-50%);
}

.dropdown-toggle-line::before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #DDDDE3;
  transform: translateY(-50%);
}

.toggle-line span {
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 8px 30px 8px 34px;
  background-color: #fff;
  color: #747480;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  cursor: pointer;
}

.toggle-line span::after {
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  margin-left: 12px;
  background-image: url("data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.166 6L8.49935 10.6667L3.83268 6' stroke='%23747480' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.toggle-line.open span::after {
  transform: rotate(180deg);
}

.chatter-list .row.search-detail-area,
.chatter-list .search-detail-area .row {
  align-items: center;
  margin-left: 0;
  margin-right: 0;
}

.chatter-list .search-detail-area .row:not(:only-child):last-child {
  margin-top: 0.5208vw;
}

.search-detail-area .form-control {
  min-height: unset;
  margin-bottom: 0;
  resize: none;
  background-color: #fff;
}

.search-detail-area .col-3 {
  width: 18.6197vw;
  margin-right: 1.171875vw;
  padding: 0 !important;
}

.search-detail-area .btn {
  height: 40px;
}

.search-detail-area .btn.btn-secondary {
  background-color: #dddde3;
  color: #2E2E38;
}

.search-detail-area .btn.btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.search-detail-area .btn.btn-primary {
  width: 148px;
  height: 40px;
}

.search-detail-area .btn.col {
  flex-basis: calc(50% - 0.2604vw);
  flex-grow: 0;
  width: calc(50% - 0.2604vw);
  padding-right: 0;
  padding-left: 0;
}

.search-detail-area .btn.col:first-child {
  background-color: #2E2E38;
  color: #fff;
}

.search-detail-area .btn.col:first-child:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.search-detail-area .btn.btn-primary:not(:disabled):not(.big):not(.disabled) {
  color: #fff;
}

.search-detail-area .btn.small {
  width: 100px;
}

.search-detail-area .btn.btn-primary.big {
  width: 148px;
  height: 186px;
}

.search-detail-area .query-button {
  flex-grow: 0;
}

.chatter-list .search-detail-area>.col,
.chatter-list .search-detail-area>[class*="col-"] {
  padding: 0 0.2604vw;
}

.chatter-list .search-detail-area .custom-select.new-query {
  width: 100%;
  height: 186px;
  overflow: auto;
}

.chatter-list .select-box {
  width: 100%;
  height: 186px;
  padding: 20px 10px;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #fff;
}

.chatter-list .select-box .select-title {
  margin-bottom: 14px;
  padding-left: 10px;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.chatter-list .search-detail-area .select-box .custom-select {
  padding: 0 !important;
  height: auto;
  min-height: unset;
  border-radius: 0;
  border: 0 none;
  background: none;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.chatter-list .select-box .custom-select option {
  margin-bottom: 4px;
  background-color: #fff;
}

.chatter-list .select-box .custom-select option:hover {
  background-color: #F6F6FA;
}

.btn-create {
  color: #FFE600;
  background-color: #0D0D17;
  width: 100px;
  height: 40px;
  /* margin-top: 30px; */
}

/* project-list 스타일 수정 */
button#project-list__BV_toggle_ {
  position: relative;
  padding: 0.533rem 2.1rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 버튼 내부의 화살표 아이콘 숨기기 */
button#project-list__BV_toggle_::after {
  display: none;
}

/* 배경 이미지 추가 */
button#project-list__BV_toggle_ {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  overflow: hidden;
}

/* status-list 스타일 수정 */
button#status-list__BV_toggle_ {
  position: relative;
  padding: 0.533rem 2.1rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 버튼 내부의 화살표 아이콘 숨기기 */
button#status-list__BV_toggle_::after {
  display: none;
}

/* 배경 이미지 추가 */
button#status-list__BV_toggle_ {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  overflow: hidden;
}


/* assignee-list 스타일 수정 */
button#assignee-list__BV_toggle_ {
  position: relative;
  padding: 0.533rem 2.1rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 버튼 내부의 화살표 아이콘 숨기기 */
button#assignee-list__BV_toggle_::after {
  display: none;
}

/* 배경 이미지 추가 */
button#assignee-list__BV_toggle_ {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
}


/* 드롭다운 토글 버튼의 너비를 100%로 설정하여 전체 너비를 차지하도록 함 */
.dropdown-toggle {
  display: inline-block;
  width: 100%;
}

.dropdown-menu {
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
}

button#assignee-list__BV_toggle_+.dropdown-menu {
  max-height: 400px;
  /* 스크롤이 나타날 최대 높이 */
  overflow-y: auto;
  /* 세로 스크롤이 필요한 경우에만 스크롤이 나타나도록 설정 */
}

.dropdown-item {
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  padding: 0.5rem 1rem;
}

.dropdown-item:hover,
.dropdown-item:focus {
  background-color: #EDEDF3;
}
</style>